import { RExpandBlock } from '../../../components/partials/RExpandBlock';

export { RExpandBlock };
